import { render, staticRenderFns } from "./CustomerInboudPage.vue?vue&type=template&id=97abd8c8&"
import script from "./CustomerInboudPage.vue?vue&type=script&lang=js&"
export * from "./CustomerInboudPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports